module.exports = __webpack_public_path__ + "img/title.b9069807.png";